/*
Copyright 2023 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { ComponentProps } from 'react';
import dynamic from 'next/dynamic';

import { Dialog as SpDialog } from '.';
import { DialogBase as SpDialogBase } from '.';
import { DialogWrapper as SpDialogWrapper } from '.';

export const Dialog = dynamic<
    JSX.LibraryManagedAttributes<
        typeof SpDialog,
        ComponentProps<typeof SpDialog>
    >
>(() => import('.').then(({ Dialog }) => Dialog), { ssr: false });
export const DialogBase = dynamic<
    JSX.LibraryManagedAttributes<
        typeof SpDialogBase,
        ComponentProps<typeof SpDialogBase>
    >
>(() => import('.').then(({ DialogBase }) => DialogBase), { ssr: false });
export const DialogWrapper = dynamic<
    JSX.LibraryManagedAttributes<
        typeof SpDialogWrapper,
        ComponentProps<typeof SpDialogWrapper>
    >
>(() => import('.').then(({ DialogWrapper }) => DialogWrapper), { ssr: false });
